module.exports = {
	"title": {
		"artist": "Słuchaj {artistName} na Qobuz",
		"album": "Słuchaj albumu {albumName} {artistName} na Qobuz",
		"track": "Słuchaj {trackName} {artistName} na Qobuz",
		"playlist": "Słuchaj playlisty {playlistName} {ownerName} na Qobuz",
		"focus": "Czytaj tę Panoramę na Qobuz"
	},
	"buttons": {
		"listen": "Słuchaj na Qobuz",
		"buy": "Kup w sklepie",
		"download": "Pobierz Qobuz na komputer Mac/PC",
		"readmore": "Czytaj więcej",
		"showless": "Afficher moins",
		"showmore": "Zobacz więcej",
		"readfocus": "Czytaj tę Panoramę na Qobuz",
		"seeSubscribes": "Voir les offres d'abonnements"
	},
	"infos": {
		"trackCount": "{count} utwor(y)ów",
		"diskCount": "{count} płyt(y)",
		"duration": {
			"long": "{hours}godz. {minutes}min.",
			"short": "{minutes}min. {seconds}sek."
		},
		"playlist": {
			"private": "Prywatna",
			"public": "Publiczna"
		},
		"hires": "Wysoka jakość"
	},
	"share": {
		"twitter": {
			"track": "Słuchaj {title} według {artist} na Qobuz",
			"album": "Słuchaj {title} według {artist} na Qobuz",
			"artist": "Słuchaj {artist} na Qobuz",
			"playlist": "Słuchaj {playlist} według {owner} na Qobuz",
			"focus": "Czytaj tę Panoramę na Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} wyk. przez {artist} jest dostępny na Qobuz!",
				"body": "Słuchaj {title} {artist} z Qobuz w wysokiej jakości: {url}\n\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} wyk. przez {artist} jest dostępny na Qobuz!",
				"body": "Słuchaj {title} {artist} z Qobuz w wysokiej jakości: {url}\n\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} jest na Qobuz!",
				"body": "Słuchaj {artist} z Qobuz w wysokiej jakości: {url}\n\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} według {owner} jest dostępna na Qobuz!",
				"body": "Słuchaj {playlist} de {owner} z Qobuz w wysokiej jakości: {url}\n\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"focus": {
				"subject": "{title}",
				"body": "Odtwórz {url}\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			}
		}
	},
	"tracklist": {
		"title": {
			"track": "Utwór",
			"album": "Utwory albumu",
			"artist": "Top utwory",
			"artist_albums": "Albumy",
			"playlist": "Utwory z playlisty"
		},
		"header": {
			"number": "#",
			"name": "Tytuł",
			"album": "Album",
			"artist": "Artysta",
			"time": "Czas trwania",
			"label": "Wytwórnia muzyczna"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Brak dostępnego utworu"
	},
	"focus": {
		"from": "Według {author}",
		"albumOverlay": " - {releaseYear} - {genre}"
	},
	"playlist": {
		"from": "Par {author}"
	},
	"notifications": {
		"subscribe": "Vous devez vous abonner à l'une des offres d'écoute illimitée de Qobuz",
		"purchase": "Vous pouvez acheter cette piste pour l'écouter et l'importer dans votre application"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/pl.json
// module id = 452
// module chunks = 0